const cssVersionMap = require('../versions');

module.exports = {
  customerChat: {
    scriptUrl:
      'https://gco-c3-web-messenger-prod.us-west-2.prodp.gcotechp.expedia.com/c3-web-messenger.js',
  },
  errorViewCssUrl: `https://vap.expedia.com/c3cards/${cssVersionMap.errorView}/payment-{{brand}}.css`, // Duplicated in server config
};
